import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);

if ('serviceWorker' in navigator) {
  if (import.meta.env.PROD) {
    window.addEventListener('load', () =>
      navigator.serviceWorker.register('/sw.js').catch(() => {})
    );
  } else {
    // A previously installed production worker can otherwise cache Vite source
    // modules and API reads while developing, making saved edits look reverted.
    navigator.serviceWorker.getRegistrations().then((registrations) =>
      Promise.all(registrations.map((registration) => registration.unregister()))
    );
    caches.keys().then((keys) => Promise.all(keys.map((key) => caches.delete(key))));
  }
}
